export default __webpack_public_path__ + "static/media/img_Projet2.427acf7f.png";